import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_expanding10cuv3ua9vajx as get_expanding } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../utils/utils.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../theming/separators.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function keyString(_this__u8e3s4, key, value) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_rem(0.5));
  view.jb7(!(value == null));
  bodyBold(view, key + ':');
  var tmp = get_expanding(view);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = value == null ? '' : value;
  var tmp_0 = view_0.vb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = value_0;
  }
  tmp_0.hbu(tmp_1);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function keyString_0(_this__u8e3s4, key, value) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_rem(0.5));
  shownDefaultFalse(view, ($this$shownDefaultFalse) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return !(value($this$shownDefaultFalse) == null);
  });
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = key + ':';
  var tmp = view_0.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value_0;
  }
  tmp.hbu(tmp_0);
  view.hbb(p_0, view_0);
  var tmp_1 = get_expanding(view);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_elvis_lhs = value($this$reactiveScope);
    var tmp$ret$9 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    this_0.set(tmp$ret$9);
    return Unit_instance;
  });
  view.hbb(p_1, view_1);
  view.lbb(tmp_1, view_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function keyMoney(_this__u8e3s4, key, value) {
  return keyString_0(_this__u8e3s4, key, ($this$keyString) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = value($this$keyString);
    var tmp0_safe_receiver = tmp == null ? null : tmp.y5r_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = MonetaryValue__toString_impl_xslc77(tmp0_safe_receiver);
    }
    return tmp_0;
  });
}
function tableEntryUnderlinedString(_this__u8e3s4, key, value) {
  // Inline function 'com.crowpay.views.components.tableEntryUnderlined' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_rem(0.5));
  view_0.lbb(get_expanding(view_0), body(view_0, key));
  body(view_0, value == null ? '' : value);
  view.hbb(p_0, view_0);
  greySeparator(view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function tableEntryUnderlinedString_0(_this__u8e3s4, key, value) {
  // Inline function 'com.crowpay.views.components.tableEntryUnderlined' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_rem(0.5));
  view_0.lbb(get_expanding(view_0), body(view_0, key));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_elvis_lhs = value($this$reactiveScope);
    var tmp$ret$1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view_0.hbb(p_1, view_1);
  view.hbb(p_0, view_0);
  greySeparator(view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function tableEntryUnderlinedMoney(_this__u8e3s4, key, value) {
  return tableEntryUnderlinedString_0(_this__u8e3s4, key, ($this$tableEntryUnderlinedString) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = value($this$tableEntryUnderlinedString).y5r_1;
    return MonetaryValue__toString_impl_xslc77(tmp$ret$0);
  });
}
function htmlKeyString(key, value) {
  return '<strong>' + key + ':<\/strong> ' + value;
}
function inlineKeyString(_this__u8e3s4, key, value) {
  return _this__u8e3s4.ccp(htmlKeyString(key, value));
}
function inlineLabel(_this__u8e3s4, label, paragraph) {
  return _this__u8e3s4.ccp('<p><strong>"' + label + '"<\/strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' + paragraph + '<\/p>');
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
//region block: exports
export {
  htmlKeyString as htmlKeyString3qkhbon8qnk4f,
  inlineKeyString as inlineKeyString1hdvsz76w276,
  inlineLabel as inlineLabel3artc1yn03kdr,
  keyMoney as keyMoneyoelmapxkkp81,
  keyString as keyString2x2ocg778b9mu,
  keyString_0 as keyString2ezqnhf3jck9c,
  tableEntryUnderlinedMoney as tableEntryUnderlinedMoney1xb094tujwxjo,
  tableEntryUnderlinedString_0 as tableEntryUnderlinedString1xi3bqljwfn1f,
  tableEntryUnderlinedString as tableEntryUnderlinedString3hj244dg60e1r,
};
//endregion

//# sourceMappingURL=keyValue.mjs.map
